module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/img_trouble04-68fadbfc4d694f2354441d363b3b44f7.png";